import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from '../../../constants/holcim';

export const NormativeTypeRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, modalClose }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal]);

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingrese el tipo de normativa"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Tipo de Normativa</h4>
            <GradientDecorationLine />
            <Form onSubmit={formikFormData.handleSubmit}>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de normativa</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Normativa"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.name || ""}
                        invalid={
                            formikFormData.touched.name && formikFormData.errors.name ? true : false
                        }
                    />
                    {formikFormData.touched.name && formikFormData.errors.name && <FormFeedback>{formikFormData.errors.name}</FormFeedback>}
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={onClosed}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            footer={null}
            children={children_form}
            width={700}
        />
    );
};